import script from "./Default.vue?vue&type=script&setup=true&lang=js"
export * from "./Default.vue?vue&type=script&setup=true&lang=js"

import "./Default.vue?vue&type=style&index=0&id=42acf410&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42acf410"]])

export default __exports__